import { Utils, type Nil } from '@pbt/pbt-ui-components'
import { useSelector } from 'react-redux'

import { ClinicStatus } from '~/api/graphql/generated/types'
import { getClinicVerificationStatus } from '~/store/reducers/constants'

export enum ClinicDisplayStatus {
  Verified = 'VERIFIED',
  Unverified = 'UNVERIFIED',
  // Closed = 'CLOSED', We will not have this for PMR phase 1
}

const VERIFIED_STATUSES = new Set([ClinicStatus.Active])

export const useGetClinicDisplayStatus = (
  statusId: string | Nil,
): ClinicDisplayStatus => {
  const clinicStatus = useSelector(getClinicVerificationStatus)
  const statusName = Utils.findById(statusId, clinicStatus)?.name

  if (!statusName) {
    return ClinicDisplayStatus.Unverified
  }

  if (VERIFIED_STATUSES.has(statusName)) {
    return ClinicDisplayStatus.Verified
  }

  return ClinicDisplayStatus.Unverified
}
